"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPointsAllowlistCreators = exports.responseSchema = void 0;
const endpointIds_1 = require("root/src/shared/descriptions/endpoints/endpointIds");
const auth_1 = require("root/src/shared/constants/auth");
const authApiClient_types_1 = require("root/src/server/util/awsClients/authApiClient.types");
const payloadSchema = {
    type: 'object',
    properties: {
        dropId: { type: 'string' },
    },
    required: ['dropId'],
    additionalProperties: false,
};
exports.responseSchema = {
    type: 'array',
    items: {
        type: 'object',
        properties: {
            platform: { type: 'string' },
            platformId: { type: 'string' },
            displayName: { type: 'string' },
            brandId: { type: 'string' },
            dropId: { type: 'string' },
        },
    },
};
exports.getPointsAllowlistCreators = {
    [endpointIds_1.GET_POINTS_ALLOWLIST_CREATORS]: {
        authentication: auth_1.authenticationTypes.authenticated,
        authenticationRole: authApiClient_types_1.AuthGroup.Admin,
        payloadSchema,
        responseSchema: exports.responseSchema,
    },
};
